import { Locale } from '@yi/core';

export function getImageSrc(locale: Locale): string {
  if (locale === 'es') {
    return 'https://brooklyn.gaia.com/v1/assets-render/7753496d-1aa2-43b2-9a05-db4d0e11ccf2?hash=c5309a93e9a10f0e6fac0e3003892d672eca39d63d823a5121f2d39cbdb665f4';
  }

  return 'https://brooklyn.gaia.com/v1/assets-render/6ab5aa02-93dc-4a81-93c6-9542a3e1cbb0?hash=c5309a93e9a10f0e6fac0e3003892d672eca39d63d823a5121f2d39cbdb665f4';
}
